import { VoidCallback } from '@deqo/foundation';
import { CodeName, EventInput, EventRouter, EventSource, Pod, PodEvents, PodRequest } from '@deqo/podopolis';
import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';

export class KioskPod extends EventRouter<PodEvents> implements Pod {

    public readonly id: string = uuid();

    constructor(public readonly clientId: string, private inbound: EventSource<any>, private outbound: EventInput<any>) {
        super();
    }

    public request<T = unknown>(outCode: CodeName, inCode: CodeName, outData?: any): Promise<T>;
    public request<T = unknown>(req: PodRequest<T>): Promise<T>;
    public request(arg0: any, arg1?: any, arg2?: any): Promise<any> {
        if (typeof (arg0) === 'object') {
            return this.request(arg0.outCode, arg0.inCode, arg0.outData);
        }
        const outCode = arg0;
        const inCode = arg1!;
        const outData = arg2;
        const outTag = uuid();
        // console.log('requ', outCode, '->', inCode);
        return new Promise((rs) => {
            this.outbound.emit(outCode, [outData, outTag]);
            const stop = this.inbound.on(inCode, ([inData, inTag]) => {
                if (outTag === inTag) {
                    rs(inData);
                    stop();
                }
            });
        });
    }

    public receive<T = any>(inCode: CodeName, callback: (data: T) => void): VoidCallback {
        // console.log('recv', inCode);
        return this.inbound.on(inCode, (([data, _tag]) => {
            callback(data);
        }));
    }

    public send(outCode: CodeName, data?: any, _reductionKey?: string): void {
        // console.log('send', outCode);
        // Do nothing?  Who cares
        this.outbound.emit(outCode, [data, uuid()]);
    }
}
